import { useDispatch, useSelector } from 'react-redux'
import { webViewSelectors, webViewSlice } from './web-view.slice'

export const webViewHooks = {
  useActiveUrl: () => useSelector(webViewSelectors.getUrl),
  useIsOpen: () => useSelector(webViewSelectors.getIsOpen),
  useHasShownFooter: () => useSelector(webViewSelectors.getHasShownFooter),
  useHasShownShareButton: () => useSelector(webViewSelectors.getHasShownShareButton),
  useShareableUrl: () => useSelector(webViewSelectors.getShareableUrl),

  useWebViewActions: () => {
    const dispatch = useDispatch()

    return {
      openWebView: (payload: {
        url: string
        hasShownFooter?: boolean
        hasShownShareButton?: boolean
        shareableUrl?: string
      }) => {
        dispatch(webViewSlice.actions.openWebView(payload))
      },
      closeWebView: () => {
        dispatch(webViewSlice.actions.closeWebView())
      },
    }
  },
}
